import React from 'react'
import moment from 'moment'
import { Trash2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import Currency from '../../currency'
import store from '../../../state/store'

const PAYMENT_TERM_LABEL = {
  monthly_credit_card: 'credit card',
  monthly_subscription_manual: 'manual payment'
}

class EnquiryCoachbitOrderPartial extends React.Component {

  onOpen = () => {
    this.props.onOpen(this.props.order.id)
  }

  onCancel = () => {
    store.emit('coachbit_order:cancel', this.props.enquiry_id, this.props.order.id)
  }

  render() {
    const order = this.props.order
    const paymentLabel = PAYMENT_TERM_LABEL[order.payment_term] || order.payment_term
    return (
      <div className="mb-2 rounded-[10px] border border-border bg-card hover:bg-muted/50">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-3 text-sm">
          <div className="flex min-w-0 flex-1 cursor-pointer flex-col leading-tight" onClick={this.onOpen}>
            <span className="font-medium">
              {order.trial_months > 0 ? (
                <span>Free <span className="font-normal text-muted-foreground">— {order.trial_months}-month trial</span></span>
              ) : (
                <React.Fragment>
                  {order.amount != null && <Currency value={Number(order.amount)} currency={order.currency_code}/>}
                  {paymentLabel && <span className="font-normal text-muted-foreground"> per month via {paymentLabel}</span>}
                </React.Fragment>
              )}
            </span>
            <span className="text-xs text-muted-foreground">
              {order.checkin_days} check-in days
              {order.trial_months > 0 && order.amount != null && (
                <span> · then <Currency value={Number(order.amount)} currency={order.currency_code}/>/month</span>
              )}
              {order.placed_at && <span> · placed {moment(order.placed_at).format('DD/MM/YYYY')}</span>}
              {order.active_order && <span> · order {order.active_order.id}</span>}
            </span>
          </div>
          {order.paid ? (
            <Badge variant="success" className="capitalize">Paid</Badge>
          ) : order.workflow_state ? (
            <Badge variant="secondary" className="capitalize">{order.workflow_state}</Badge>
          ) : null}
          <span className="ml-auto shrink-0">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="destructive" size="icon-sm" title="Cancel order"><Trash2 /></Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem>Cancel</DropdownMenuItem>
                <DropdownMenuItem variant="destructive" onSelect={this.onCancel}>Confirm</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </span>
        </div>
      </div>
    )
  }
}

export default EnquiryCoachbitOrderPartial
